import translationEN from "./en/translation.json";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { initOptions } from "./initOptions";

const resources = {
  en: {
    translation: translationEN,
  },
};
export class LocalizationService {
  static async init(onInit = () => {}) {
    return i18next
      .use(initReactI18next)
      .init({
        ...initOptions,
        resources,
      })
      .then(() => {
        onInit();
      });
  }

  static async changeLanguage(language) {
    await i18next.changeLanguage(language);
  }
}
